import { defineComponent as _defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';
import { getHasCard, getIsFollow, getSupplyDetail, getSupplyTel, getWechatSDKSign } from '@/api/miscellaneous';
import { useStore } from 'vuex';
import userStoreModule from '@/store/modules/user';
import RestrictDialog from '@/components/RestrictDialog.vue';
import config from '@/config';

export default /*#__PURE__*/_defineComponent({
  __name: 'SupplyDetail',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const router = useRouter();

const isNotFollow = ref(false);

const isRealName = ref(false);

const detail = ref<any>({});

const restrictShow = ref(false);
const restrictCode = ref('');
const tel = ref('');
const isShowTel = ref(false);
const video = ref<any>(null);

onMounted(() => {
    getSupplyDetail({ id: (route.query.id ?? route.query.state) as string }).then((res: any) => {
        res.specifications = JSON.parse(res.specifications);
        if (res.video.length) {
            (res.photos as string[]).splice(0, 1);
        }
        detail.value = res;
        //分享
        share(detail.value);
    });
    isFollow();
});

const isFollow = () => {
    const userId = userStoreModule.userDetail.user.id;
    getIsFollow(userId).then((res: any) => {
        isNotFollow.value = !res.subscripte;
    });
};

const share = (_detail: any) => {
    //getWechatSDKSign({url: location.href.split('#')[0]}).then(res => {
    wx.updateTimelineShareData({
        title: `${_detail.title}`, // 分享标题
        desc: `${_detail.profile}`,
        link: `${config.webHost}/SupplyDetail?id=${_detail.id}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: `${_detail.photos[0].value}`, //'https://mdd-static.oss-cn-hangzhou.aliyuncs.com/app/h5/seek_logo_new.png', // 分享图标
        success: function () {
            // 设置成功
        },
    });
    wx.updateAppMessageShareData({
        title: `${_detail.title}`, // 分享标题
        desc: `${_detail.profile}`,
        link: `${config.webHost}/SupplyDetail?id=${_detail.id}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: `${_detail.photos[0].value}`, //'https://mdd-static.oss-cn-hangzhou.aliyuncs.com/app/h5/seek_logo_new.png', // 分享图标
        success: function () {
            // 设置成功
        },
    });
    //});
};

const getDetail = () => {
    getSupplyDetail({ id: route.query.id as string }).then((res: any) => {
        res.specifications = JSON.parse(res.specifications);
        if (res.video.length) {
            (res.photos as string[]).splice(0, 1);
        }
        detail.value = res;
    });
};
const cancel = () => {
    tel.value = '';
    isShowTel.value = false;
};
const call = () => {
    window.location.href = 'tel:' + tel.value;
};
const getTel = (): void => {
    let id = ((route.query.id ?? route.query.state) as string) || '';

    getHasCard().then(res => {
        isRealName.value = !res;
        if (!res) {
            isRealName.value = true;
            return;
        } else {
            getSupplyTel({ id })
                .then(res => {
                    tel.value = res as string;
                    isShowTel.value = true;
                })
                .catch(e => {
                    let { code } = e;
                    if ([121, 122].includes(code)) {
                        restrictCode.value = code;
                        restrictShow.value = true;
                    }
                });
        }
    });


};

const cancelRealName=()=> {
        isRealName.value = false;
    }

    const gotoRealName=()=> {
        router.push({ name: 'RealName', query: { id: route.query.id, detailType: 'SupplyDetail', back: 'true' } });
    }

const jumpApplet = () => {
    // getWechatAppUrl({
    //     url: 'pages/tabBar/platform/platform',
    // }).then((res: any) => {
    //     const {openlink} = JSON.parse(res as string);
    //     window.location.href = openlink;
    // });
    userStoreModule.getUserInfo().then(res => {
        console.log(res, '----');
    });
    router.push({ name: 'SellerShop', query: { id: detail.value.userId } });
};

const __returned__ = { route, router, isNotFollow, isRealName, detail, restrictShow, restrictCode, tel, isShowTel, video, isFollow, share, getDetail, cancel, call, getTel, cancelRealName, gotoRealName, jumpApplet, useRoute, useRouter, onMounted, ref, getHasCard, getIsFollow, getSupplyDetail, getSupplyTel, getWechatSDKSign, useStore, userStoreModule, RestrictDialog, config }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})